<button *ngIf="isShowEdit()" kendoButton iconClass="far fa-edit" title="Изменить" look="flat" (click)="edit()"></button>
<button
  *ngIf="isShowUndo()"
  kendoButton
  iconClass="fa-solid fa-rotate-left"
  title="Отменить"
  look="flat"
  (click)="undo()"
></button>
